<template>

  <div class="hello">
    <h1>{{ msg }}</h1>
    <h2>
<!--      <Icon type="logo-chrome" />-->
      <span style="font-weight: bold; text-decoration: underline;">Mission {{ missionLevel }}</span>
      <Icon v-if="!bgmPaused" style="color: #f60;" type="ios-pause" v-on:click="togglePlay" />
      <Icon v-if="bgmPaused" style="color: #f60;" type="ios-play" v-on:click="togglePlay" />
      <audio loop autoplay preload="auto" id="music1">
        <source src="../assets/qijizaixian.mp3">
        该浏览器不支持audio属性
      </audio>
    </h2>

    <!-- <div>{{keyValue}}</div> -->
    <div id="question-container">
      <span style="margin-right: 30px;" v-for="(part,i) in questionStates" :key="i">
        <span :class="[{'correct': item == 1}, {'incorrect': item == 2}, 'question-item']" v-for="(item, j) in part" :key="j">
          {{questions[$data.currRow][i][j]}}
        </span>
      </span>
    </div>

    <div class="key-area-row">
      <Button id="keycode-49" :class="[$data.keyPressed.indexOf('keycode-49') > -1?'ivu-btn ivu-btn-info':'']">1</Button>
      <Button id="keycode-50" :class="[$data.keyPressed.indexOf('keycode-50') > -1?'ivu-btn ivu-btn-info':'']">2</Button>
      <Button id="keycode-51" :class="[$data.keyPressed.indexOf('keycode-51') > -1?'ivu-btn ivu-btn-info':'']">3</Button>
      <Button id="keycode-52" :class="[$data.keyPressed.indexOf('keycode-52') > -1?'ivu-btn ivu-btn-info':'']">4</Button>
      <Button id="keycode-53" :class="[$data.keyPressed.indexOf('keycode-53') > -1?'ivu-btn ivu-btn-info':'']">5</Button>
      <Button id="keycode-54" :class="[$data.keyPressed.indexOf('keycode-54') > -1?'ivu-btn ivu-btn-info':'']">6</Button>
      <Button id="keycode-55" :class="[$data.keyPressed.indexOf('keycode-55') > -1?'ivu-btn ivu-btn-info':'']">7</Button>
      <Button id="keycode-56" :class="[$data.keyPressed.indexOf('keycode-56') > -1?'ivu-btn ivu-btn-info':'']">8</Button>
      <Button id="keycode-57" :class="[$data.keyPressed.indexOf('keycode-57') > -1?'ivu-btn ivu-btn-info':'']">9</Button>
      <Button id="keycode-48" :class="[$data.keyPressed.indexOf('keycode-48') > -1?'ivu-btn ivu-btn-info':'']">0</Button>
      <Button id="keycode-189" :class="[$data.keyPressed.indexOf('keycode-189') > -1?'ivu-btn ivu-btn-info':'']">-</Button>
      <Button id="keycode-187" :class="[$data.keyPressed.indexOf('keycode-187') > -1?'ivu-btn ivu-btn-info':'']">+</Button>
      <Button id="keycode-8" :class="[$data.keyPressed.indexOf('keycode-8') > -1?'ivu-btn ivu-btn-info':'']">delete</Button>
    </div>

    <div class="key-area-row">
      <Button id="keycode-9" :class="[$data.keyPressed.indexOf('keycode-9') > -1?'ivu-btn ivu-btn-info':'']">Tab</Button>
      <Button id="keycode-81" :class="[$data.keyPressed.indexOf('keycode-81') > -1?'ivu-btn ivu-btn-info':'']">Q</Button>
      <Button id="keycode-87" :class="[$data.keyPressed.indexOf('keycode-87') > -1?'ivu-btn ivu-btn-info':'']">W</Button>
      <Button id="keycode-69" :class="[$data.keyPressed.indexOf('keycode-69') > -1?'ivu-btn ivu-btn-info':'']">E</Button>
      <Button id="keycode-82" :class="[$data.keyPressed.indexOf('keycode-82') > -1?'ivu-btn ivu-btn-info':'']">R</Button>
      <Button id="keycode-84" :class="[$data.keyPressed.indexOf('keycode-84') > -1?'ivu-btn ivu-btn-info':'']">T</Button>
      <Button id="keycode-89" :class="[$data.keyPressed.indexOf('keycode-89') > -1?'ivu-btn ivu-btn-info':'']">Y</Button>
      <Button id="keycode-85" :class="[$data.keyPressed.indexOf('keycode-85') > -1?'ivu-btn ivu-btn-info':'']">U</Button>
      <Button id="keycode-73" :class="[$data.keyPressed.indexOf('keycode-73') > -1?'ivu-btn ivu-btn-info':'']">I</Button>
      <Button id="keycode-79" :class="[$data.keyPressed.indexOf('keycode-79') > -1?'ivu-btn ivu-btn-info':'']">O</Button>
      <Button id="keycode-80" :class="[$data.keyPressed.indexOf('keycode-80') > -1?'ivu-btn ivu-btn-info':'']">P</Button>
      <Button id="keycode-219" :class="[$data.keyPressed.indexOf('keycode-219') > -1?'ivu-btn ivu-btn-info':'']">[</Button>
      <Button id="keycode-221" :class="[$data.keyPressed.indexOf('keycode-221') > -1?'ivu-btn ivu-btn-info':'']">]</Button>
      <Button id="keycode-220" :class="[$data.keyPressed.indexOf('keycode-220') > -1?'ivu-btn ivu-btn-info':'']">\</Button>
    </div>

    <div class="key-area-row">
      <Button :class="[$data.keyPressed.indexOf('keycode-20') > -1?'ivu-btn ivu-btn-info':'']">caps lock</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-65') > -1?'ivu-btn ivu-btn-info':'']">A</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-83') > -1?'ivu-btn ivu-btn-info':'']">S</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-68') > -1?'ivu-btn ivu-btn-info':'']">D</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-70') > -1?'ivu-btn ivu-btn-info':'']">F</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-71') > -1?'ivu-btn ivu-btn-info':'']">G</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-72') > -1?'ivu-btn ivu-btn-info':'']">H</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-74') > -1?'ivu-btn ivu-btn-info':'']">J</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-75') > -1?'ivu-btn ivu-btn-info':'']">K</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-76') > -1?'ivu-btn ivu-btn-info':'']">L</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-186') > -1?'ivu-btn ivu-btn-info':'']">;</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-222') > -1?'ivu-btn ivu-btn-info':'']">'</Button>
      <Button id="keycode-13" :class="[$data.keyPressed.indexOf('keycode-13') > -1?'ivu-btn ivu-btn-info':'']">Enter</Button>
    </div>

    <div class="key-area-row">
      <Button :class="[$data.keyPressed.indexOf('keycode-16') > -1?'ivu-btn ivu-btn-info':'']">shift</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-90') > -1?'ivu-btn ivu-btn-info':'']">Z</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-88') > -1?'ivu-btn ivu-btn-info':'']">X</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-67') > -1?'ivu-btn ivu-btn-info':'']">C</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-86') > -1?'ivu-btn ivu-btn-info':'']">V</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-66') > -1?'ivu-btn ivu-btn-info':'']">B</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-78') > -1?'ivu-btn ivu-btn-info':'']">N</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-77') > -1?'ivu-btn ivu-btn-info':'']">M</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-188') > -1?'ivu-btn ivu-btn-info':'']">,</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-190') > -1?'ivu-btn ivu-btn-info':'']">.</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-191') > -1?'ivu-btn ivu-btn-info':'']">/</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-16') > -1?'ivu-btn ivu-btn-info':'']">shift</Button>
    </div>

    <div class="key-area-row">
      <Button :class="[$data.keyPressed.indexOf('keycode-17') > -1?'ivu-btn ivu-btn-info':'']">control</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-18') > -1?'ivu-btn ivu-btn-info':'']">option</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-91') > -1?'ivu-btn ivu-btn-info':'']">command</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-32') > -1?'ivu-btn ivu-btn-info':'']" style="width: 200px;">Space</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-91') > -1?'ivu-btn ivu-btn-info':'']">command</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-18') > -1?'ivu-btn ivu-btn-info':'']">option</Button>
      <!-- <Button :class="[$data.keyPressed.indexOf('keycode-37') > -1?'ivu-btn ivu-btn-info':'']">&lt;</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-38') > -1?'ivu-btn ivu-btn-info':'']">^</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-40') > -1?'ivu-btn ivu-btn-info':'']">down</Button>
      <Button :class="[$data.keyPressed.indexOf('keycode-39') > -1?'ivu-btn ivu-btn-info':'']">&gt;</Button> -->
    </div>

    <!-- <input autofocus="autofocus" @keydown="keyPress($event)" @keyup="keyUnPress($event)" @blur="focusAgain($event)" class="hidden" /> -->

    <div v-if="showNextEntrance" style="margin-top: 50px; font-size:2rem;">
      恭喜通关！
      <Button type="primary" v-on:click="go2Next">下一关</Button>
      <Button type="success" shape="circle" v-on:click="onceAgain">再来一次</Button>
    </div>

    <!-- 弹出层 -->
    <div>
<!--      <i-button @click="modal2 = true">Custom header and footer</i-button>-->
      <modal v-model="modal2" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <icon type="ios-checkmark-circle"></icon>
          <span>恭喜通关！</span>
        </p>
        <div style="text-align:left;">
          <img src="../assets/victory.gif" style="width:100%;">
          <p>迪迦奥特曼在绝境中爆发，使出最强绝招奥特光线，击败了小怪兽！努力吧，光之子！</p>
        </div>
        <div slot="footer">
          <i-button type="error" size="large" long :loading="modal_loading" @click="go2Next">下一关</i-button>
        </div>
      </modal>
    </div>
  </div>

</template>

<script>
import KeycodeDict from '@/utils/KeycodeDict'

export default {
  name: 'Keyboard',
  data () {
    return {
      msg: '基本键位练习',
      modal2: false,
      modal_loading: false,
      bgmPaused: false,
      //questions是一个二维的题库数组，每一个子数组就是一组字符
      questions: [],
      questionStates: [], //状态：0，初始化；1，正确；2：错误；
      scores: 0,
      currRow: 0,   //行
      currPart: 0,  //组
      currIdx: 0,   //下标
      currState: 0,
      keyValue: '',
      keyPressed: [],
      showNextEntrance: false, //是否显示下一关入口
      missionLevel: 0, //关卡级别
      missions: [
        '[["AAAAA","BBBBB"],["CCCCC","DDDDD"],["EEEEE","FFFFF"],["GGGGG","HHHHH"],["IIIII","JJJJJ"],["KKKKK","LLLLL"],["MMMMM","NNNNN"],["OOOOO","PPPPP"],["QQQQQ","RRRRR"],["SSSSS","TTTTT"],["UUUUU","VVVVV"],["WWWWW","XXXXX"],["YYYYY","ZZZZZ"]]',
        '[["ASDFG","HJKL"],["QWERT","YUIOP"],["ZXCVB","NM"],["12345","67890"]]',
        '[["09876","54321"],["MN","BVCXZ"],["POIUY","TREWQ"],["LKJH","GFDSA"]]',
        '[["CAMERA","COMPUTER"],["COOKER","ELECTRIC"],["FRIDGE","TELEPHONE"],["LAMP","LAPTOP"]]',
        '[["OVEN","RADIO"],["TELEVISION","VIDEO"],["PLAYER","MACHINE"],["ADDRESS","APARTMENT"]]',
        '[["ARMCHAIR","BATHROOM"],["BATHTUB","BED"],["BEDROOM","BIN"],["BLANKET","BOOTCASE"]]',
        '[["BOOKSHELF","BOWL"],["BOX","CARPET"],["CHAIR","COMB"],["COOKER","CUPBOARD"]]',
        '[["CURTAIN","DESK"],["DOOR","DOWNSTAIRS"],["DRAWER","ENTRANCE"],["FLAT","FLOOR"]]',
        '[["FURNITURE","GARAGE"],["GARDEN","GATE"],["HALL","HOME"],["HOUSE","KEY"]]',
        '[["KITCHEN","LIGHT"],["LIVE","EXIT"],["PILLOW","REFRIGERATOR"],["ROOF","ROOM"]]',
        '[["RUBBISH","SAFE"],["SHELF","SHOWER"],["SINK","SOAP"],["SOFA","TOILET"]]',
      ], //关卡数据
    }
  },
  created: function(){
    //TODO 需要改为从服务器拉取题目信息ajax
    //初始化当前关卡（第一关）
    this.missionLevel = 1
    this.initMission(this.missions[this.missionLevel - 1])
  },
  methods: {
    keyPress() {
      this.keyValue = window.event.keyCode
      let keyId = 'keycode-' + this.keyValue;

      //防止在数组中插入重复数据，keyPressed数组用来标记组合键输入
      if(this.keyPressed.indexOf(keyId) == -1) {
        this.keyPressed.push(keyId);
      }
      let onEvent = window.event
      //console.log(onEvent.keyCode + "," + onEvent.shiftKey)
      //主要逻辑：判断玩家输入的字符和题目当前的字符是否一致


      // if (this.keyValue == 9) { //禁用Tab键默认行为
      //   e.returnValue = false;
      // }

      //通过currRow、currPart和currIdx三个维度获取当前要求输入的字符(expectChar)
      var part = this.questions[this.currRow][this.currPart]
      var expectChar = part[this.currIdx]
      //按下时需要判断是否为正确答案
      console.log('expect:' + expectChar + ', input:' + this.keycodeDict.get(this.keyValue) + ', key:' + this.keyValue)
      //如果输入错误，则需要临时性修改字符颜色
      if(expectChar != this.keycodeDict.get(this.keyValue)) {
        this.questionStates[this.currPart][this.currIdx] = 2
      }
      //如果输入正确，则把游标向下一个字符移动
      if(expectChar == this.keycodeDict.get(this.keyValue)) {
        //先修改答题结果
        this.questionStates[this.currPart][this.currIdx] = 1
        //然后开始移动游标
        if (this.currIdx < this.questions[this.currRow][this.currPart].length - 1) {
          this.currIdx++
        } else {
          //如果当前row的当前part已经输入结束，则跳转到下一个part
          //如果已经是最后一个Part了，则跳转到下一行
          if (this.currPart < this.questions[this.currRow].length - 1) {
            this.currPart++
          } else {
            //如果已经到达最后一行，则开始弹出结束提示
            if(this.currRow < this.questions.length - 1) {
              this.currRow++
              //清空当前行的答题状态
              this.initRowStates(this.currRow)
            } else {
              console.log('questionStates===>' + this.questionStates)
              console.log('questions===>' + this.questions)
              // this.$Modal.info({
              //   title: '提示',
              //   content: '已完成所有课程，当前得分：100分'
              // })
              //this.showNextEntrance = true
              this.modal2 = true
            }
            this.currPart = 0
          }
          this.currIdx = 0
        }
      } else {
        console.log('input error')
      }
    },
    keyUnPress() {
      //TODO 这里要优化下，松开一个键的时候，不要清楚数组内的所有按键标记
      this.keyPressed = [];
    },
    //初始化当前行的状态数组
    initRowStates(index){
      //clear
      this.questionStates = []
      //先要解析一下当前行
      var row = this.questions[index]
      for(let i = 0; i < row.length; i++) {
        let part = row[i]
        let arr = new Array()
        for (let j = 0; j < part.length; j++) {
          arr.push(0)
        }
        this.questionStates.push(arr)
      }
      console.log(this.questionStates)
    },
    //再来一次
    onceAgain(){
      // 重置当前行
      this.initRowStates(this.currRow)
      // 隐藏提示
      this.showNextEntrance = false
      this.currRow  = 0
      this.currPart = 0
      this.currIdx  = 0
    },
    //初始化关卡
    initMission(jsondata){
      //清空上一组数据
      this.questions = []
      //将服务器数据进行格式转换
      var rows = JSON.parse(jsondata)

      for(let i = 0; i < rows.length; i++) {
        var parts = rows[i]
        //遍历所有part，并进行解析和分组
        var arr = new Array()
        for(let j = 0; j < parts.length; j++) {
          var part = parts[j]
          var part_char_arr = part.split('')
          arr.push(part_char_arr)
        }
        this.questions.push(arr)
      }
      //初始化第一行的状态，全部为0：未回答
      this.initRowStates(0)

      //document.addEventListener('onkeyup',this.keyUnPress)
      document.onkeyup = this.keyUnPress
      document.onkeydown = this.keyPress
      //定义键位code字典
      this.keycodeDict = new KeycodeDict()
    },
    // 下一关
    go2Next(){
      this.modal_loading = true;
      setTimeout(() => {
        this.modal_loading = false;
        this.modal2 = false;

        this.missionLevel += 1
        //检查是不是有下一关
        if (this.missionLevel > this.missions.length) {
          this.$Modal.info({
            title: '提示',
            content: '已完成所有关卡，你怎么这么牛！'
          })
        } else {
          this.$Message.success('准备好了吗？马上开始第'+this.missionLevel+'关！');
          this.initMission(this.missions[this.missionLevel - 1])
          this.showNextEntrance = false
        }
        this.currRow  = 0
        this.currPart = 0
        this.currIdx  = 0
      }, 1000);
    },
    //切换BGM播放
    togglePlay() {
      let audio = document.getElementById('music1')
      if (audio.paused) {
        audio.play()
        this.bgmPaused = false
      } else {
        audio.pause()
        this.bgmPaused = true
      }
    },
  },
  mounted () {
　　 //console.log(this.$refs.keycode13)
　}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.hidden {
  position: absolute;
  top: 0;
  left: 0;
}
.key-area-row {
  margin-top: 5px;
  margin-bottom: 5px;
}
.question-item {
  font-size: 2rem;
}
.question-item {
  font-size: 2rem;
}
.question-item.correct {
  font-size: 2rem;
  color: deepskyblue;
}
.question-item.incorrect {
  font-size: 2rem;
  color: deeppink;
}
</style>



// WEBPACK FOOTER //
// src/components/Keyboard.vue